import axios from "axios";
import { API_URL } from "../appConstants";

export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
  },
  timeout: 30000, // 30 seconds
});

axiosInstance.interceptors.request.use((config) => {
  const latestToken = localStorage.getItem("token");

  if (!config.headers) {
    config.headers = {};
  }

  if (latestToken) {
    config.headers.Authorization = `Bearer ${latestToken}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});